<template>
    <div
        class="transaction-row"
        :class="{ 'transaction-row--active': isOpened }"
    >
        <div
            @click="toggleDetails"
            class="d-flex align-items-center justify-content-between transaction-row__content"
        >
            <div class="transaction-row__information d-flex align-items-center">
                <div
                    v-if="transaction.network_background_color && transaction.network_name"
                    class="transaction-row__network-icon mr-2 mr-lg-4"
                >
                    <div
                        class="rounded-circle d-flex align-items-center justify-content-center"
                        :style="{
                            backgroundColor: transaction.network_background_color
                        }"
                    >
                        <span class="letter-icon">
                            {{ transaction.network_name| firstLettersLimit }}
                        </span>
                    </div>
                </div>
                <div class="flex-grow-1">
                    <p
                        v-if="transaction.program_name"
                        class="transaction-row__program-name mb-0 d-flex justify-content-between"
                    >
                        {{ transaction.program_name || "Advertiser unknown" }}
                    </p>
                    <p
                        v-if="
                            transaction.date_transaction ||
                                transaction.time_transaction
                        "
                        class="transaction-row__date mb-0  w-100"
                    >
                        {{ transaction.date_transaction }}
                        {{ transaction.time_transaction }}
                    </p>
                    <p
                        v-if="transaction.domain"
                        class="transaction-row__domain mb-0 d-none d-lg-inline"
                    >
                        <b>Domain:</b> {{ transaction.domain }}
                    </p>
                </div>
            </div>
            <span
                v-if="getStatus"
                class="d-flex align-items-center d-md-none transaction-row__mobile-price"
            >
                <span
                    v-if="transformCurrency && typeof(transaction.amount) === 'number'"
                    :class="[getStatus]"
                    class="text-white transaction-row__badge d-inline mr-1"
                />
                {{ transformCurrency }}{{ transaction.amount | toDec }}
            </span>
            <div
                class="transaction-row__visitor-profile transaction-row-visitor-profile"
            >
                <div
                    class="transaction-row-visitor-profile__item rounded-circle"
                    v-if="hasTransactionClickID(transaction)"
                >
                    <img
                        class="integration-image ml-1 mr-1"
                        src="@/assets/images/sales-overview/google_ads-icon.svg"
                        alt="ga"
                    />
                </div>
                <div
                    v-if="hasGAIntegration(transaction)"
                    class="transaction-row-visitor-profile__item rounded-circle"
                >
                    <img
                        class="integration-image ml-1 mr-1"
                        src="@/assets/images/sales-overview/google_analytics.svg"
                        alt="ga"
                    />
                </div>
                <div
                    v-if="hasBAIntegration(transaction)"
                    class="transaction-row-visitor-profile__item rounded-circle"
                >
                    <img
                        class="integration-image ml-1 mr-1"
                        src="@/assets/images/microsoft.svg"
                        alt="microsoft"
                    />
                </div>
                <div
                    v-if="hasFBIntegration(transaction)"
                    class="transaction-row-visitor-profile__item rounded-circle"
                >
                    <img
                        class="integration-image ml-1 mr-1"
                        src="@/assets/images/facebook.svg"
                        alt="fb"
                    />
                </div>
                <div
                    v-if="hasKickbiteIntegration(transaction)"
                    class="transaction-row-visitor-profile__item rounded-circle"
                >
                    <img
                        class="integration-image ml-1 mr-1"
                        src="@/assets/images/kickbite-mini.svg"
                        alt="fb"
                    />
                </div>
            </div>
            <div
                class="transaction-row__additional-information transaction-row-additional-information"
            >
                <div
                    class="d-flex align-items-center justify-content-end justify-content-lg-between"
                >
                    <div
                        class="flex-grow-1 d-none d-lg-flex justify-content-center"
                    >
                        <div
                            class="transaction-row-additional-information__subid"
                        >
                            <p
                                v-if="transaction.sub_id"
                                class="mb-0 font-weight-bold d-inline"
                            >
                                SUB ID
                            </p>
                            <p
                                :id="'subid' + transaction.id"
                                class="text-dark mb-0 transaction-row__subid-text d-block-inline"
                            >
                                {{ transaction.sub_id }}
                            </p>
                            <d-tooltip
                                :target="'#subid' + transaction.id"
                                placement="lefttop"
                                container=".transactions-group"
                            >
                                {{ transaction.sub_id }}
                            </d-tooltip>
                        </div>
                        <div
                            class="transaction-row-additional-information__description"
                        >
                            <p
                                v-if="transaction.transaction_description"
                                class="mb-0 d-inline font-weight-bold"
                            >
                                DESCRIPTION
                            </p>
                            <p
                                :id="'description' + transaction.id"
                                class="text-dark mb-0 transaction-row__description-text"
                            >
                                {{ transaction.transaction_description }}
                            </p>
                            <d-tooltip
                                :target="'#description' + transaction.id"
                                placement="lefttop"
                                container=".transactions-group"
                            >
                                {{ transaction.transaction_description }}
                            </d-tooltip>
                        </div>
                        <div
                            v-if="getStatus"
                            class="transaction-row-additional-information__status d-flex align-items-center justify-content-center"
                        >
                            <span
                                :class="[getStatus]"
                                class="text-white transaction-row__badge"
                            >
                                <span
                                    v-if="transaction.internal_transaction_status_name"
                                    class="d-none d-lg-inline"
                                >
                                    {{
                                        transaction.internal_transaction_status_name
                                    }}
                                </span>
                            </span>
                        </div>
                    </div>
                    <div
                        class="transaction-row-additional-information__amount d-none d-md-flex align-items-center"
                    >
                        <div>
                            <p class="mb-0 font-weight-bold">
                                AMOUNT
                            </p>
                            <p
                                v-if="transformCurrency && typeof(transaction.amount) === 'number'"
                                class="text-dark mb-0"
                            >
                                <span
                                    v-if="getStatus"
                                    :class="[getStatus]"
                                    class="text-white transaction-row__badge d-inline-block d-lg-none"
                                />
                                {{ transformCurrency
                                }}{{ transaction.amount | toDec }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="transaction-row__details-chevron">
                <span class="material-icons">
                    {{ isOpened ? "expand_less" : "expand_more" }}
                </span>
            </div>
        </div>
        <transition name="fade">
            <div
                class="transaction-row__content transaction-row__content--scrollable"
                v-if="isOpened"
            >
                <div>
                    <h5 class="mb-3 text-dark">
                        Transaction Details:
                    </h5>
                    <table class="table mb-0">
                        <tbody>
                            <tr
                                v-for="item in getBasicInformation"
                                :key="item.label"
                            >
                                <td v-if="item.value" class="collapse-td">
                                    {{ item.label }}
                                </td>
                                <td v-if="item.value" class="collapse-td">
                                    {{ item.value }}
                                </td>
                            </tr>
                            <tr
                                v-if="
                                    transaction.custom_sub_ids !== null &&
                                        transaction.custom_sub_ids.length
                                "
                            >
                                <td class="collapse-td">
                                    Custom Sub ID
                                </td>
                                <td class="collapse-td">
                                    <span
                                        v-for="subId in transaction.custom_sub_ids"
                                        :key="subId"
                                    >
                                        {{ subId }}
                                    </span>
                                </td>
                            </tr>

                            <tr v-if="hasGAIntegration(transaction)">
                                <td class="collapse-td">
                                    Google Analytics User ID
                                </td>
                                <td class="collapse-td">
                                    {{ sessionMetaData.ga.client_id }}
                                </td>
                            </tr>

                            <tr v-if="hasBAIntegration(transaction)"
                            >
                                <td class="collapse-td">
                                    Microsoft Advertising ID
                                </td>
                                <td class="collapse-td">
                                    {{ sessionMetaData.ba.click_id }}
                                </td>
                            </tr>

                            <tr v-if="hasFBIntegration(transaction)">
                                <td class="collapse-td">
                                    FBC
                                </td>
                                <td class="collapse-td">
                                    {{ sessionMetaData.fb.fbc }}
                                </td>
                            </tr>

                            <tr v-if="hasTransactionClickID(transaction)">
                                <td class="collapse-td">
                                    Google Ads visitor ID
                                </td>
                                <td class="collapse-td">
                                    {{ sessionMetaData.ga.click_id }}
                                </td>
                            </tr>

                            <tr v-if="hasKickbiteIntegration(transaction)">
                                <td class="collapse-td">
                                    Kickbite User ID
                                </td>
                                <td class="collapse-td">
                                    {{ sessionMetaData.kb.kbuid }}
                                </td>
                            </tr>

                            <tr
                                v-if="
                                    sessionMetaData && sessionMetaData.referrer
                                "
                            >
                                <td class="collapse-td">
                                    Referrer URL
                                </td>
                                <td class="collapse-td text-break">
                                    {{ sessionMetaData.referrer.url }}
                                </td>
                            </tr>

                            <tr v-if="transaction.google_data_aggregate && transaction.google_data_aggregate.campaign">
                                <td class="collapse-td">
                                    Campaign
                                </td>
                                <td class="collapse-td">
                                    {{ transaction.google_data_aggregate.campaign }}
                                </td>
                            </tr>

                            <tr v-if="transaction.google_data_aggregate && transaction.google_data_aggregate.keyword">
                                <td class="collapse-td">
                                    Keyword
                                </td>
                                <td class="collapse-td">
                                    {{ transaction.google_data_aggregate.keyword }}
                                </td>
                            </tr>

                            <tr v-for="item in getUtmInformation" :key="item.label">
                                <td v-if="item.value" class="collapse-td">
                                    {{ item.label }}
                                </td>
                                <td v-if="item.value" class="collapse-td">
                                    {{ item.value }}
                                </td>
                            </tr>
                            <tr v-if="hasGAIntegration(transaction) || hasBAIntegration(transaction)">
                                <td>
                                    Visitor profiles
                                </td>
                                <td>
                                    <div
                                        class="transaction-row__visitor-profile p-0 justify-content-start d-flex"
                                    >
                                        <div
                                            class="transaction-row-visitor-profile__item rounded-circle"
                                            v-if="hasTransactionClickID(transaction)"
                                        >
                                            <img
                                                class="integration-image ml-1 mr-1"
                                                src="@/assets/images/sales-overview/google_ads-icon.svg"
                                                alt="ga"
                                            />
                                        </div>
                                        <div
                                            v-if="hasGAIntegration(transaction)"
                                            class="transaction-row-visitor-profile__item rounded-circle"
                                        >
                                            <img
                                                class="integration-image ml-1 mr-1"
                                                src="@/assets/images/sales-overview/google_analytics.svg"
                                                alt="ga"
                                            />
                                        </div>
                                        <div
                                            v-if="hasBAIntegration(transaction)"
                                            class="transaction-row-visitor-profile__item rounded-circle"
                                        >
                                            <img
                                                class="integration-image ml-1 mr-1"
                                                src="@/assets/images/microsoft.svg"
                                                alt="microsoft"
                                            />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import Currencies from "@/models/currencies.model.js";
import TransactionStatus from "@/helpers/transactionStatus";
import detectVisitorProfiles from "../../mixins/detectVisitorProfiles";

export default {
    mixins: [detectVisitorProfiles],
    props: {
        transaction: {
            required: true
        },
        currency: {
            required: true
        }
    },
    data() {
        return {
            isOpened: false
        };
    },

    methods: {
        toggleDetails() {
            this.isOpened = !this.isOpened;
        }
    },
    computed: {
        transformCurrency() {
            return Currencies[this.currency];
        },
        sessionMetaData() {
            return this.getTransactionMetaData(this.transaction)
        },
        getStatus() {
            if (this.transaction.internal_transaction_status_name) {
                return TransactionStatus.getStatusClass(
                    this.transaction.internal_transaction_status_name
                );
            }
            return null;
        },
        getBasicInformation() {
            return [
                {
                    value:
                        this.transaction.program_name || "Advertiser unknown",
                    label: "Program name"
                },
                {
                    value: this.transaction.domain,
                    label: "Domain"
                },
                {
                    value: this.transaction.date_click
                        ? `${this.transaction.date_click} ${
                              this.transaction.time_click
                          }`
                        : null,
                    label: "Click"
                },
                {
                    value: this.transaction.unique_id,
                    label: "Network ID"
                },
                {
                    value: this.transaction.transaction_description,
                    label: "Description"
                },
                {
                    value: this.transaction.sub_id,
                    label: "Sub ID"
                },
                {
                    value: this.transaction.network_name,
                    label: "Network name"
                },
                {
                    value: this.transaction.store_name,
                    label: "Store name"
                },
                {
                    value: this.transaction.approved_at,
                    label: "Approved at"
                },
                {
                    value: this.transaction.disapproved_at,
                    label: "Disapproved at"
                }
            ];
        },
        getUtmInformation() {
            if (!this.getUtmTags) {
                return [];
            }
            return [
                {
                    value: this.getUtmTags.utm_source,
                    label: "UTM source"
                },
                {
                    value: this.getUtmTags.utm_medium,
                    label: "UTM medium"
                },
                {
                    value: this.getUtmTags.utm_campaign,
                    label: "UTM campaign"
                },
                {
                    value: this.getUtmTags.utm_term,
                    label: "UTM term"
                },
                {
                    value: this.getUtmTags.utm_content,
                    label: "UTM content"
                }
            ];
        },

        getUtmTags() {
            if (
                this.sessionMetaData &&
                this.sessionMetaData.hasOwnProperty("ga")
            ) {
                if (this.sessionMetaData.ga.hasOwnProperty("utm_tags")) {
                    return JSON.parse(this.sessionMetaData.ga.utm_tags);
                }
            }
            return null;
        }
    }
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: 0.2s cubic-bezier(0.445, 0.05, 0.55, 0.95);
    max-height: 500px;
    overflow: hidden;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    max-height: 0;
}

.tooltip.tooltip-inner {
    font-size: 16px;
}
</style>
